export const getRedirectLink = (routeLink: string, pathname: string) => {
  if (pathname === '/') {
    return routeLink;
  }
  const params = new URLSearchParams();
  params.set('from', pathname);

  return `${routeLink}?${params.toString()}`;
};
